export const HUDDLE_MODE_START_EVENT = "mem:huddle:start";

export const requestStartHuddleMode = () => {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(new Event(HUDDLE_MODE_START_EVENT));
};
